import React, { useState, useEffect } from 'react'
import Stack from '@mui/joy/Stack/index.js'
import Link from '@mui/joy/Link/index.js'
import Button from '@mui/joy/Button/index.js'
import { fetchAuthSession, signOut } from 'aws-amplify/auth'
import AdminPanelSettingsIcon from '@mui/icons-material/AdminPanelSettings'
import tranebotImage from '../images/tranebot.png'

export default function MessagesPaneHeader({ admin, view, onToggleView }) {
  const [session, setSession] = useState()
  useEffect(() => {
    void (async () => {
      setSession(await fetchAuthSession())
    })()
  }, [])
  return (
    <Stack
      direction="row"
      justifyContent="space-between"
      sx={{
        borderBottom: '1px solid',
        borderColor: 'divider',
        backgroundColor: 'background.body',
      }}
      py={{ xs: 2, md: 2 }}
      px={{ xs: 1, md: 2 }}
    >
      <img src={tranebotImage} width="200" />
      <Stack spacing={1} direction="row" alignItems="center">
        {admin && view === 'chat' && (
          <Button
            variant="outlined"
            color="neutral"
            startDecorator={<AdminPanelSettingsIcon />}
            onClick={onToggleView}
            sx={{ mr: 2 }}
          >
            Admin Panel
          </Button>
        )}
        <div>
          {session?.tokens?.idToken?.payload?.email ?? ''} (
          <Link
            onClick={() => {
              signOut()
                .then(() => {
                  window.location.reload()
                })
                .catch((error) => {
                  console.error('Sign out error', error)
                })
            }}
          >
            sign out
          </Link>
          )
        </div>
      </Stack>
    </Stack>
  )
}
